import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import themeable from 'zignal-landscape/lib/themeable';
import Slider from 'zignal-landscape/lib/Slider';

const sliderValues = [1, 2, 3, 4, 5];
const sliderMarks = {
  '1': {label:'Low', style:{marginLeft: '-10px'}},
  '2': {label:''},
  '3': {label:'Moderate'},
  '4': {label:''},
  '5': {label:'High', style:{marginLeft: '-30px'}}
};
const sliderLabels = {'1': 'Low', '2': 'Slightly Low', '3':'Moderate', '4': 'Slightly High', '5': 'High'};
const valueMapping = {
  '1': -1,
  '2': -0.5,
  '3': 0,
  '4': 0.5,
  '5': 1
};

const reverseValueMapping = {
  '-1': 1,
  '-0.5': 2,
  '0': 3,
  '0.5': 4,
  '1': 5
};

class ConfidenceSlider extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      confidenceValue: reverseValueMapping[props.value],
    };

    this.updateConfidenceValue = this.updateConfidenceValue.bind(this);
  }

  updateConfidenceValue(value) {
    const { confidenceLevelChanged } = this.props;
    this.setState({confidenceValue: value});
    confidenceLevelChanged(valueMapping[value]);
  }

  render() {
    const { styles, sliderDisabled } = this.props;
    const { confidenceValue } = this.state;

    const cx = classNames.bind(styles); // eslint-disable-line react/jsx-no-bind
    const labelClasses = cx({
      confidenceLevelLabel: true,
      disabled: sliderDisabled
    });

    return (
      <div className={styles.confidenceSlider}>
        <div className={labelClasses}>Bot Confidence Level</div>
        <Slider
          selectedValue={confidenceValue}
          values={sliderValues}
          valueLabels={sliderLabels}
          marks={sliderMarks}
          onChange={this.updateConfidenceValue}
          disabled={sliderDisabled}
        />
      </div>
    );
  }
}

ConfidenceSlider.propTypes = {
  styles: PropTypes.object,
  value: PropTypes.number,
  sliderDisabled: PropTypes.bool,
  confidenceLevelChanged: PropTypes.func
};

ConfidenceSlider.defaultProps = {
  value: 0,
  sliderDisabled: true,
};

export default themeable(ConfidenceSlider);
